"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var star_empty_svg_1 = __importDefault(require("./../../img/star-empty.svg"));
var star_half_svg_1 = __importDefault(require("./../../img/star-half.svg"));
var star_full_svg_1 = __importDefault(require("./../../img/star-full.svg"));
var circle_svg_1 = __importDefault(require("./../../img/circle.svg"));
var Rating_styled_1 = require("./Rating.styled");
var clsx_1 = __importDefault(require("clsx"));
var Rating = function (_a) {
    var _b = _a.selectable, selectable = _b === void 0 ? false : _b, onSelect = _a.onSelect, _c = _a.value, value = _c === void 0 ? -1 : _c, _d = _a.type, type = _d === void 0 ? 'circle' : _d, _f = _a.className, className = _f === void 0 ? '' : _f, _g = _a.showUnfilled, showUnfilled = _g === void 0 ? true : _g;
    var _h = react_1.useState(-1), hoverPointer = _h[0], setHoverPointer = _h[1];
    var _j = react_1.useState(-1), stars = _j[0], setStars = _j[1];
    var handleEnter = function (_e, idx) {
        setHoverPointer(idx);
        // $(e.currentTarget).one('mouseleave', handleLeave)
    };
    var handleLeave = function () {
        setHoverPointer(-1);
    };
    var handleClick = function (idx) {
        setStars(idx);
        if (onSelect) {
            onSelect(idx + 1);
        }
    };
    react_1.useEffect(function () {
        if (typeof value === 'number' && value > -1) {
            setStars(value - 1);
        }
    }, [value]);
    return (react_1.default.createElement(Rating_styled_1.StyledContainer, { className: clsx_1.default(className, { editable: selectable }) }, new Array(5).fill('').map(function (v, idx) {
        var attrs = {
            key: idx,
            width: 20,
            height: 20,
            viewBox: type === 'circle' ? '0 0 512 512' : '0 0 67 63',
        };
        if (selectable) {
            var attrsEditable = {
                onMouseEnter: function (e) {
                    handleEnter(e, idx);
                },
                onMouseLeave: handleLeave,
                onClick: function () {
                    handleClick(idx);
                },
            };
            if (idx <= hoverPointer || idx <= stars) {
                if (type === 'circle') {
                    return react_1.default.createElement(circle_svg_1.default, __assign({ fill: '#cf0101' }, attrs, attrsEditable));
                }
                else {
                    return react_1.default.createElement(star_full_svg_1.default, __assign({ fill: '#cf0101' }, attrs, attrsEditable));
                }
            }
            if (type === 'circle') {
                return react_1.default.createElement(circle_svg_1.default, __assign({}, attrs, attrsEditable));
            }
            else {
                return react_1.default.createElement(star_empty_svg_1.default, __assign({}, attrs, attrsEditable));
            }
        }
        else {
            if (idx <= stars) {
                if (type === 'circle') {
                    return react_1.default.createElement(circle_svg_1.default, __assign({ fill: '#cf0101' }, attrs));
                }
                else {
                    return react_1.default.createElement(star_full_svg_1.default, __assign({ fill: '#cf0101' }, attrs));
                }
            }
            else if (idx > stars && idx < stars + 1) {
                return react_1.default.createElement(star_half_svg_1.default, __assign({ fill: '#cf0101' }, attrs));
            }
            if (showUnfilled) {
                if (type === 'circle') {
                    return react_1.default.createElement(circle_svg_1.default, __assign({}, attrs));
                }
                else {
                    return react_1.default.createElement(star_empty_svg_1.default, __assign({}, attrs));
                }
            }
        }
    })));
};
exports.default = Rating;
